import { render, staticRenderFns } from "./notes-row.vue?vue&type=template&id=1a877346&"
import script from "./notes-row.vue?vue&type=script&lang=ts&"
export * from "./notes-row.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports